import styles from "./routeDetail.module.css"
import { useMemo, useState } from "react"
import { Address, addressHelpers, GoogleMap, AddressData, RouteDuration } from "../../../../../features/address"
import { Icon, Section } from "../../../../../features/ui"
import { RouteJourney } from "../route-journey/routeJourney"

type Props = {
    addresses: Map<string, Address>
    onChangeSortedAddresses?: (sortedAddressesData: AddressData[]) => void
}

export const RouteDetail = (props: Props) => {
    const { addresses, onChangeSortedAddresses } = props
    
    const [sortedAddresses, setSortedAddresses] = useState<string[]>([])
    const [routeDuration, setRouteDuration] = useState<RouteDuration>()

    const { describeAddress } = addressHelpers
    
    const duration = useMemo(() =>
        routeDuration && `${routeDuration.hours > 0 ? routeDuration.hours + 'h ' : ''}${routeDuration.minutes}min`
    , [routeDuration])
    
    const addressesData: AddressData[] = useMemo(() =>
        Array.from(addresses.entries()).map(([shipmentId, address]) => ({
            key: shipmentId,
            address: describeAddress(address)
        }))
    , [addresses])
    
    const handleRouteChange = (sortedAddressesData: AddressData[] = [], duration: RouteDuration) => {
        setSortedAddresses(sortedAddressesData.map(addressData => addressData.address))
        setRouteDuration(duration)
        onChangeSortedAddresses && onChangeSortedAddresses(sortedAddressesData)
    }

    return (
        <Section
            id="route-detail"
            title="Trayecto de Ruta"
            space={12}
        >
            <div className={styles.container}>
                {routeDuration && (
                    <div className={styles.duration}>
                        <Icon icon="clock" />
                        <span>Tiempo estimado: {duration}</span>
                    </div>
                )}
                <div className={styles.stopsList}>
                    <RouteJourney sortedAddresses={sortedAddresses} />
                </div>
                <GoogleMap 
                    addressesData={addressesData}
                    onChangeRoute={handleRouteChange}
                />
            </div>
        </Section>
    )
}
